import create from './create'
import update from './update'

export default { create, update }
